export enum UsersOrganizationsPermissionsWriteType {
    IsOwner = 1,
    RevenuesWrite = 1 << 1,
    ExpensesWrite = 1 << 2,
}

// Máximo é Math.pow(2, 31)
